export default {
  metaTitle: '管理平台积分计划',
  pageTitle: '管理平台积分计划',
  region: '国别',
  content1: '当前积分抵扣比例为',
  content2: '单次抵扣上线为',
  content3: '加入积分计划',
  content4: '请确认您已知悉内容含义，此操作不可逆',
  content5: '积分兑换计划',
  main1: 'Kilimall开放了积分抵扣，用于推广平台和店铺；用户可以使用积分来抵扣部分支付。',
  main2: '积分抵扣比例由平台设定. 通常值(不含运费部分)为',
  main3: '单次抵扣上线为',
  main4: '抵扣比例在促销和推广期内可能发生变化。',
  main5: '认同此协议并加入后，您的店铺内的商品支持积分抵扣，并且在商品详情页会向用户展示。',
  main6: '加入此积分计划后，在结算时用户使用积分抵扣的金额中有{discount}%由平台来进行结算',
  main7: '如果您的店铺未加入积分计划，商品会向用户展示不支持积分抵扣',
  main8: '此操作不可逆，请仔细操作。',
  confirmTitle: '提交后不能取消，您确定要提交吗?',
  okText: '确定',
  cancelText: '取消',
  success: '提交成功',
  error: '请勾选协议'
}
